import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

// Full-bleed hero for the /advertise hub and each track landing page.
// One badge, one headline, one supporting sentence, one CTA group.
export function AdvertiseHero({ eyebrow, title, subtitle, primaryCta, secondaryCta, stat, className }) {
  return (
    <section className={cn('relative hero-gradient noise-overlay', className)}>
      <div className="mx-auto max-w-5xl px-4 py-20 text-center sm:px-6 lg:px-8 sm:py-24">
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 rounded-full bg-white/15 px-3 py-1 text-xs font-medium text-white backdrop-blur">
            {eyebrow}
          </span>
        )}
        <h1 className="font-display mx-auto mt-5 max-w-3xl text-4xl font-bold text-white sm:text-5xl">{title}</h1>
        {subtitle && <p className="mx-auto mt-4 max-w-2xl text-white/85">{subtitle}</p>}
        {(primaryCta || secondaryCta) && (
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            {primaryCta && (
              <Button asChild size="lg" className="rounded-full bg-white text-blue-700 hover:bg-white/90" data-testid={primaryCta.testId}>
                <Link to={primaryCta.to}>{primaryCta.label}</Link>
              </Button>
            )}
            {secondaryCta && (
              <Button asChild size="lg" variant="secondary" className="rounded-full bg-blue-800 text-white hover:bg-blue-900" data-testid={secondaryCta.testId}>
                <Link to={secondaryCta.to}>{secondaryCta.label}</Link>
              </Button>
            )}
          </div>
        )}
        {stat && <p className="mt-6 text-sm font-medium text-white/80">{stat}</p>}
      </div>
    </section>
  );
}
